import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';


import { HttpClient } from '@angular/common/http';
import { Organization } from '../../types/person/organization';
import { BaseRestService } from '../common/BaseRestService';


@Injectable()
export class OrganizationDirectoryRestService extends BaseRestService {

    constructor(private http: HttpClient) {
        super('directory');
    }

    getIdmOrganization(): Observable<Organization []> {
        return this.http.get<Organization []>(this.getEndpoint(['idm', 'report', 'organization']));
    }

}
